import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=2107def8&scoped=true"
import script from "./AdminProfile.vue?vue&type=script&lang=js"
export * from "./AdminProfile.vue?vue&type=script&lang=js"
import style0 from "./AdminProfile.vue?vue&type=style&index=0&id=2107def8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2107def8",
  null
  
)

export default component.exports